export const SCHEDULED_EMAIL_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Beklemede',
  RUNNING: 'Çalışıyor',
  SENT: 'Gönderildi',
  FAILED: 'Başarısız',
  CANCELLED: 'İptal Edildi',
};

export const SCHEDULED_EMAIL_TEMPLATE_LABELS: Record<string, string> = {
  OFFER: 'Teklif',
  REPORT: 'Rapor',
  INVOICE: 'Fatura',
  'email/welcome.html': 'Karşılama',
  'email/proposal.html': 'Teklif',
  'email/proposal-revise.html': 'Teklif Revizyonu',
  'email/mail-ortak.html': 'Ortak Bilgilendirmesi',
  'email/mail-ortak-revise.html': 'Ortak Revizyonu',
  'email/planlama.html': 'Planlama Hatırlatması',
  'email/complete-report.html': 'Rapor Tamamlandı',
  'email/complete-financial.html': 'Finansal Bilgi',
  'email/complete-ortak.html': 'Ortak Tamamlandı',
  'email/7days.html': '7 Gün Hatırlatması',
  'email/21days.html': '21 Gün Hatırlatması',
  'email/31days.html': '31 Gün Hatırlatması',
  'email/no-login-30days.html': '30 Gün Giriş Yapılmadı',
  'email/pending-proposal-reminder.html': 'Bekleyen Teklif Hatırlatması',
  'email/yaklasan.html': 'Yaklaşan Hatırlatması',
};

export const getScheduledEmailStatusLabel = (status?: string | null) => {
  if (!status) return '-';
  return SCHEDULED_EMAIL_STATUS_LABELS[status] ?? status;
};

export const getScheduledEmailStatusColor = (status?: string | null) => {
  if (!status) return 'default';
  switch (status) {
    case 'PENDING':
      return 'warning';
    case 'RUNNING':
      return 'processing';
    case 'SENT':
      return 'success';
    case 'FAILED':
      return 'error';
    case 'CANCELLED':
      return 'default';
    default:
      return 'default';
  }
};

export const getScheduledEmailTemplateLabel = (template?: string | null) => {
  if (!template) return '-';
  return SCHEDULED_EMAIL_TEMPLATE_LABELS[template] ?? template;
};
